import React from 'react'

const AccessdeniedIcon = () => {
    return (
        <div>
            <svg
                width="80"
                height="80"
                viewBox="0 0 120 118"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    fill-rule="evenodd"
                    clip-rule="evenodd"
                    d="M17.9123 16.8386C29.1631 5.84643 44.3004 -0.208541 59.9959 0.00506334C70.9982 -0.144671 80.8861 1.51595 90.1295 6.97004C90.6923 7.30214 90.7705 8.07902 90.2964 8.52876L79.6716 18.6069C79.3594 18.903 78.8931 18.9648 78.5098 18.7696C72.4065 15.6612 67.0994 15.0276 60.002 15.0276C48.3832 15.0276 37.2237 19.5859 28.9039 27.7306C20.5837 35.8751 15.7612 46.9615 15.4646 58.6258C15.6263 70.3256 20.4083 81.4815 28.7591 89.641C37.1099 97.8006 48.3457 102.296 59.9959 102.137C71.6461 102.291 82.8807 97.795 91.2324 89.6369C99.5842 81.4787 104.37 70.325 104.539 58.6258C104.371 51.9925 102.738 45.5462 99.8316 39.7213C99.6366 39.3307 99.7089 38.8579 100.018 38.5495L109.982 28.6092C110.436 28.1561 111.194 28.2418 111.524 28.7921C116.882 37.731 119.851 48.0102 120 58.6217C119.55 74.3018 113.032 89.1879 101.828 100.119C90.6253 111.05 75.6202 117.165 60 117.165C44.3796 117.165 29.3747 111.05 18.1715 100.119C6.96843 89.1879 0.44978 74.3018 0 58.6217C0.218541 42.86 6.66151 27.8307 17.9123 16.8386Z"
                    fill="#FE4343"
                />
                <path
                    d="M97.5151 12.1678C97.9061 11.7777 98.54 11.7777 98.931 12.1678L106.542 19.7605C106.933 20.1506 106.933 20.783 106.542 21.173L41.1589 86.3995C40.7679 86.7895 40.134 86.7895 39.743 86.3995L32.132 78.8067C31.741 78.4167 31.741 77.7843 32.132 77.3942L97.5151 12.1678Z"
                    fill="#A82626"
                />
            </svg>
        </div>
    )
}

export default AccessdeniedIcon
